import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import DataBlocksTable from "./DataBlocksTable";
import DataBlocksForm from "./DataBlocksForm";
import DataBlocksDeleteModal from "./DataBlocksDeleteModal";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const DataBlocksPage = () => {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {hasPermission(Permission.ViewToolManagementDataBlocks, permissionSet ?? []) ? (
        <div className={`layout__contentPage__${theme}`}>
          <DataBlocksTable />
          <DataBlocksForm />
          <DataBlocksDeleteModal />
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default DataBlocksPage;
